import { Column, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

interface IHowItWorksCardProps {
  icon: string;
  title: string;
  description: string;
}

export const HowItWorksCard: React.FC<IHowItWorksCardProps> = ({ icon, title, description }) => {
  return (
    <Column align="center" gap={3} px={5} className="flex-1">
      <img src={icon} alt={title} style={{ width: 60, height: 60 }} />
      <Typography as="span" bold variant="body1" color={colors.primary[500]} textAlign="center">
        {title}
      </Typography>
      <Typography as="span" variant="body1" color={colors.neutral[600]} textAlign="center">
        {description}
      </Typography>
    </Column>
  );
};
